// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"3ffdc439","422":"387627eb","492":"2cee88b2","700":"82342b82","706":"3be97b92","822":"520d4a9f","874":"600dc0b9","977":"5ac5322f"}[chunkId] + ".chunk.js";
};